<span style="display:flex;" *ngIf="displayAsList">
    <span style="display:inline-block" class="item-thumbnail">
        <button *ngIf="item.ClassID!='CL' && item.ClassID!='TAG' && item.ClassID!='CD' && item.ClassID!='50'"
            mat-icon-button disabled></button>
        <mat-icon [matMenuTriggerFor]="itemMenu" *ngIf="item.ClassID=='CL'">style</mat-icon>
        <mat-icon [matMenuTriggerFor]="itemMenu" *ngIf="item.ClassID=='TAG'"
            fontSet="material-symbols-outlined">stacks</mat-icon>
        <!-- <mat-icon *ngIf="item.ClassID=='CD'">style</mat-icon> -->
        <img *ngIf="item.ClassID=='CD'" class="item-thumbnail-image" [src]="imageCardURL"
            [ngStyle]="{width:'40px', height:'40px'}" mat-button [matMenuTriggerFor]="itemMenu" />
        <img *ngIf="item.ClassID=='50'" class="item-thumbnail-image" [src]="imageURL"
            [ngStyle]="{width:'40px', height:'40px'}" mat-button [matMenuTriggerFor]="itemMenu" />
    </span>

    <span style="margin-left: 2px;">
        {{item.ItemDescription}}
        <span class="inventoryID"><br />
            {{item.InventoryID}}
        </span>
    </span>
    <span style="margin-left:auto;"></span>
    <quantity-input #quantityInput (onNonNumericInput)="onNonNumericInput.emit($event)"
        (onValueChange)="updateQuantity(item, $event)" [value]="qty" [maxlength]="2"
        [buttonBGColor]="LifeCycleColor(item.LifeCycle)" [buttonFGColor]="LifeCycleContrastColor(item.LifeCycle)">
    </quantity-input>

    <mat-menu #itemMenu="matMenu">
        <a mat-menu-item [href]="'https://www.mayerfabrics.com/item/'
                + (item.ClassID=='50' ? item.InventoryID.substring(1) : item.PatternClass)
                + '?utm_source=RepApp&utm_medium=CustOrd&utm_campaign=Sales'" target="MayerRepAppItem">
            <mat-icon fontSet="material-symbols-outlined">captive_portal</mat-icon>
            <span>View on mayerfabrics.com</span>
        </a>
        <a mat-menu-item [href]="'https://www.mayerfabrics.com/specifications/'
                + (item.ClassID=='50' ? item.InventoryID.substring(1) : item.PatternClass)
                + '?utm_source=RepApp&utm_medium=CustOrd&utm_campaign=Sales'" target="MayerRepAppItemSpecPDF">
            <mat-icon>description</mat-icon>
            <span>View Item Spec Sheet (PDF)</span>
        </a>
        <a mat-menu-item *ngIf="item.ClassID=='CD'"
            [href]="'https://images.mayerfabrics.com/product/' + item.PatternClass + '/card'"
            target="MayerRepAppInteractiveCardPDF">
            <mat-icon>file_open</mat-icon>
            <span>View Interactive Card (PDF)</span>
        </a>
    </mat-menu>
</span>

<span style="display:flex;" *ngIf="displayAsGrid">
    [X]
</span>